// /src/components/mdm/reducers/mdmReducer.js

import axios from "axios";
import { cloneDeep } from "lodash";
import { toast } from "react-toastify";
import { setMdmApps } from "../../../reducers/appReducer";

/* -------------------- INITIAL STATE -------------------- */
const INITIAL_STATE = {
  mdmConfig: [],
  loadingConfig: true,
  loadedConfig: false,
  loadingHydratedConfig: false,
  loadedHydratedConfig: false,
  loadedData: false,
  loadingData: false,
  data: [],
  rollBackData: [],
  error: null,
  // mdmApps: [],
  mdmAppsLoading: false,
  mdmAppsLoaded: false,
  loadingAppendData: false,
  actions: [],
  lastAction: {},
  actionsRequestId: null,

  rowCount: null,
  nextRowToLoad: null,
  fullLoad: false,
  refresh: false,
  info: "",
  errorMessage: "",
  lastId: -1,
  externalFilter: [],
  externalFilterUpdate: false,
  selectedProjectIdx: -1,
  projects: [],
  mdmApps: [],
};

/* -------------------- ACTION TYPES -------------------- */
const SET_CONFIG = "SET_CONFIG";
const SET_CONFIG_BEGIN = "SET_CONFIG_BEGIN";
const SET_CONFIG_ERROR = "SET_CONFIG_ERROR";
const SET_DATA = "SET_DATA";
const SET_DATA_BEGIN = "SET_DATA_BEGIN";
const ADD_DATA = "ADD_DATA";
const REMOVE_DATA = "REMOVE_DATA";
const APPEND_DATA = "APPEND_DATA";
const BEGIN_SET_DATA_APPEND = "BEGIN_SET_DATA_APPEND";
const SET_MDM_APPS_STATUS = "SET_MDM_APPS_STATUS";
const BEGIN_SET_MDM_APPS = "BEGIN_SET_MDM_APPS";
const SET_ACTIONS = "SET_ACTIONS";
const REQUEST_ACTIONS = "REQUEST_ACTIONS";
const SET_FULL_LOAD = "SET_FULL_LOAD";
const SET_REFRESH = "SET_REFRESH";

const SET_INFO_DIALOG = "SET_INFO_DIALOG";
const SET_ERROR_DIALOG = "SET_ERROR_DIALOG";
const SET_EXT_FILTER = "SET_EXT_FILTER";
const SET_EXT_FILTER_UPDATE = "SET_EXT_FILTER_UPDATE";
const SET_LOADED_DATA_STATUS = "SET_LOADED_DATA_STATUS";
const DUPLICATE_ROW = "DUPLICATE_ROW";
const MERGE_HYDRATED_CONFIG = "MERGE_HYDRATED_CONFIG";
const SET_NEXT_ROW_TO_LOAD = "SET_NEXT_ROW_TO_LOAD";
const UPDATE_LOV_VALUES = "UPDATE_LOV_VALUES";
export const UPDATE_ACTION_RUN = "UPDATE_ACTION_RUN";
const UPDATE_TABLE_ROW_COUNT = "UPDATE_TABLE_ROW_COUNT";
/* -------------------- ACTION CREATORS -------------------- */

// const fetchReportListSuccess = () => {
//   return { type: FETCH_REPORT_LIST_SUCCESS };
// };
const setConfig = (config) => {
  return { type: SET_CONFIG, payload: config };
};
const setConfigBegin = () => ({
  type: SET_CONFIG_BEGIN,
});
const setHydrateConfigBegin = () => ({
  type: "SET_HYDRATE_CONFIG_BEGIN",
});
const setHydrateConfigSuccess = () => ({
  type: "SET_HYDRATE_CONFIG_SUCCESS",
});
const setConfigError = (error) => {
  return { type: SET_CONFIG_ERROR, payload: error };
};
const setData = (data, rowCount, nextRow) => {
  return { type: SET_DATA, payload: data, rowCount, nextRow };
};
const setActions = (actions, lastRunAction, requestId) => {
  return { type: SET_ACTIONS, payload: actions, lastRunAction, requestId };
};
// requestId is a monotonically-increasing counter, not the table name: two
// getActions(table) calls for the SAME table (e.g. the user navigates away
// and back before an earlier request's retry backoff has exhausted) need to
// be told apart too, not just requests for different tables. Recorded
// synchronously the moment getActions(table) is dispatched, so SET_ACTIONS
// can tell any earlier, now-superseded request apart from the latest one
// actually in flight, and ignore it.
let nextActionsRequestId = 0;
const requestActions = (requestId) => ({ type: REQUEST_ACTIONS, requestId });
// const setDataBegin = () => ({
//   type: SET_DATA_BEGIN
// });

export const addData = (row) => {
  return { type: ADD_DATA, payload: row };
};
const removeData = (rows) => {
  return { type: REMOVE_DATA, payload: rows };
};
// const appendData = (rows, nextRow) => {
//   return { type: APPEND_DATA, payload: rows, nextRow };
// };
const setMdmAppsStatus = (apps) => {
  return { type: SET_MDM_APPS_STATUS, payload: apps };
};
const setGetAppBegin = () => ({
  type: BEGIN_SET_MDM_APPS,
});
// const setDataAppendBegin = () => ({
//   type: BEGIN_SET_DATA_APPEND
// });
const reducerSetFullLoad = (status) => ({
  type: SET_FULL_LOAD,
  payload: status,
});
const reducerSetExternalFilter = (filter) => ({
  type: SET_EXT_FILTER,
  payload: filter,
});
const reducerSetExternalFilterUpdate = (status) => ({
  type: SET_EXT_FILTER_UPDATE,
  payload: status,
});
const reducerSetLoadedData = (status) => ({
  type: SET_LOADED_DATA_STATUS,
  payload: status,
});
const reducerSetRefresh = (status) => ({
  type: SET_REFRESH,
  payload: status,
});
const setInfoDialog = (message) => ({
  type: SET_INFO_DIALOG,
  payload: message,
});
const setErrorDialog = (message) => ({
  type: SET_ERROR_DIALOG,
  payload: message,
});
export const duplicateRow = (newRow) => ({
  type: DUPLICATE_ROW,
  payload: newRow,
});
export const setNextRowToLoad = (count) => ({
  type: SET_NEXT_ROW_TO_LOAD,
  payload: count,
});
export const updateLovValues = (lovs) => ({
  type: UPDATE_LOV_VALUES,
  payload: lovs,
});
export const updateActionRun = (actionId, lastRunTime, lastRunBy) => ({
  type: UPDATE_ACTION_RUN,
  payload: { actionId, lastRunTime, lastRunBy },
});
export const incrementLastId = () => ({
  type: "INCREMENT_LAST_ID",
});
export const incrementLastIdBy = (n) => ({
  type: "INCREMENT_LAST_ID_BY",
  payload: n,
});
export const updateRowField = (rowId, field, newValue) => ({
  type: "UPDATE_ROW_FIELD",
  payload: { rowId, field, newValue },
});
export const updateTableRowCount = (tableIdx, newCount) => ({
  type: UPDATE_TABLE_ROW_COUNT,
  payload: { tableIdx, newCount },
});

/* -------------------- ASYNC ACTION CREATORS -------------------- */
export const setExternalFilter = (filter) => {
  return (dispatch) => {
    dispatch(reducerSetExternalFilter(filter));
  };
};
export const doSetErrorDialog = (message) => {
  return (dispatch) => {
    dispatch(setErrorDialog(message));
  };
};
export const doSetInfoDialog = (message) => {
  return (dispatch) => {
    dispatch(setInfoDialog(message));
  };
};
export const setLoadedData = (status) => {
  return (dispatch) => {
    dispatch(reducerSetLoadedData(status));
  };
};
export const setExternalFilterUpdate = (status) => {
  return (dispatch) => {
    dispatch(reducerSetExternalFilterUpdate(status));
  };
};
export const setFullLoad = (status) => {
  return (dispatch) => {
    dispatch(reducerSetFullLoad(status));
  };
};
export const setRefresh = (status) => {
  return (dispatch) => {
    dispatch(reducerSetRefresh(status));
  };
};
export const getMdmConfig = (appId, projectId, signal = null) => {
  return (dispatch) => {
    dispatch(setConfigBegin());
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/getMdmConfig`,
        { appId, tableId: projectId },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
          signal,
        },
      )
      .then((response) => {
        dispatch(setConfig(response.data.config));
      })
      .catch((error) => {
        if (axios.isCancel(error) || error?.code === "ERR_CANCELED") return;

        dispatch(setConfigError(error.response.data.message));
      });
  };
};
export const hydrateMdmConfig = (appId, signal = null) => {
  return (dispatch) => {
    dispatch(setHydrateConfigBegin());
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/getFullMdmConfig`,
        { appId },
        {
          headers: { ClientToken: localStorage.getItem("clientToken") },
          signal,
        },
      )
      .then((response) => {
        // Dispatch an action to store the full config in your redux store.
        //dispatch(setConfig(response.data.config));
        dispatch({ type: MERGE_HYDRATED_CONFIG, payload: response.data.config });
        dispatch(setHydrateConfigSuccess());
      })
      .catch((error) => {
        if (axios.isCancel(error) || error?.code === "ERR_CANCELED") return;
        console.error("Error hydrating full config");
        // Optionally dispatch an error action.
        dispatch(setConfigError(error.response.data.message));
      });
  };
};

// Retries a few times with a short backoff before giving up - the Run Action
// dropdown/button are only rendered once `actions` is non-empty (see
// dataManagement/index.js), so a request that fails outright used to leave that
// entire control permanently missing for the rest of the page load, with no
// indication anything had gone wrong (the old catch did nothing at all).
const MAX_GET_ACTIONS_ATTEMPTS = 3;
const fetchActions = (dispatch, table, requestId, attempt) => {
  axios
    .post(
      `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/getActions`,
      { table },
      {
        headers: {
          ClientToken: localStorage.getItem("clientToken"),
        },
      },
    )
    .then((response) => {
      dispatch(setActions(response.data.actions, response.data.lastRunAction, requestId));
    })
    .catch((error) => {
      if (attempt < MAX_GET_ACTIONS_ATTEMPTS - 1) {
        setTimeout(() => fetchActions(dispatch, table, requestId, attempt + 1), 1000 * (attempt + 1));
        return;
      }
      console.error("Error fetching MDM actions for table", table, error);
      toast.error("Couldn't load Run Actions for this table. Try refreshing the page.");
    });
};

export const getActions = (table) => {
  return (dispatch) => {
    const requestId = ++nextActionsRequestId;
    dispatch(requestActions(requestId));
    fetchActions(dispatch, table, requestId, 0);
  };
};

/**
 * Immediately clears the config and shows a loading state.
 * Call synchronously when switching apps so the old table list is never
 * rendered for the new app while the async requests are in-flight.
 */
export const clearMdmConfig = () => {
  return (dispatch) => {
    dispatch(setConfigBegin());
  };
};

export const resetError = () => {
  return (dispatch) => {
    dispatch(setErrorDialog(""));
  };
};
export const resetInfo = () => {
  return (dispatch) => {
    dispatch(setInfoDialog(""));
  };
};

export const setMdmData = (data, rowCount = null, nextRow = null) => {
  return (dispatch) => {
    dispatch(setData(data, rowCount, nextRow));
  };
};
// export const addNewRow = row => {
//   return dispatch => {
//     dispatch(addData(row));
//     dispatch(setRefresh(true));
//   };
// };

// export const addNewRow = row => {
//   return dispatch => {
//     if (Array.isArray(row)) {
//       dispatch(addData(row));
//     } else {
//       dispatch(duplicateRow(row));
//     }
//     dispatch(setRefresh(true));
//   };
// };

export const removeRows = (rows) => {
  return (dispatch) => {
    dispatch(removeData(rows));
  };
};

export const getMdmApps = () => {
  return (dispatch) => {
    dispatch(setGetAppBegin());
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/getMdmApps`,
        {},
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        dispatch(setMdmApps(response.data.apps));
        dispatch(setMdmAppsStatus(response.data.apps));
      })
      .catch((error) => {
        //dispatch(getMdmData(table.srcTableId));
      });
  };
};
function mergeConfigs(currentConfig, incomingConfig, { preferIncomingData = false } = {}) {
  if (!currentConfig || currentConfig.length === 0) return incomingConfig;
  // Create a map of current config items by id
  const currentMap = {};
  currentConfig.forEach((item) => {
    currentMap[item.id] = item;
  });
  // For each item in incomingConfig, decide whether the incoming item's `data`
  // or the previously-stored item's `data` should win.
  //
  // - getMdmConfig (SET_CONFIG) only ever returns full column `data` for the
  //   single selected table; every other table comes back without a `data`
  //   key. When its response resolves, that selected table's fresh `data`
  //   (reflecting the latest schema/LOV/permission changes) must win over
  //   whatever hydrateMdmConfig may have already stored for it, since the
  //   selected-table response is authoritative for that table. Tables the
  //   incoming payload has no `data` for must keep whatever was already
  //   there (i.e. hydrated data), so preferIncomingData=true still falls
  //   back to the previous data when the incoming item lacks a `data`
  //   property.
  //
  // - hydrateMdmConfig (MERGE_HYDRATED_CONFIG) returns `data` for every
  //   table, but since both requests start concurrently, its response can
  //   resolve after the selected-table response has already populated fresh
  //   `data` for the selected table. In that case the previously-stored
  //   (selected-table) data must be preferred over the hydrated payload, so
  //   a fresher selected-table load is never clobbered by a slower/older
  //   hydration response. Tables that don't have prior data yet still get
  //   populated from the hydrated payload.
  return incomingConfig.map((item) => {
    const prior = currentMap[item.id];
    if (!prior) return item;
    if (preferIncomingData) {
      return { ...item, data: item.data || prior.data };
    }
    return { ...item, data: prior.data || item.data };
  });
}
/* -------------------- REDUCER -------------------- */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CONFIG_BEGIN:
      return {
        ...state,
        loadingConfig: true,
        loadedConfig: false,
        loadingData: false,
        loadedData: false,
        error: null,
      };
    case SET_CONFIG:
      // getMdmConfig only returns full column `data` for the single selected
      // table; every other table comes back without a `data` key. Since
      // getMdmConfig and hydrateMdmConfig (getFullMdmConfig) both kick off
      // concurrently, this response can resolve either before or after the
      // hydration response.
      //
      // The selected table's `data` here is authoritative (it reflects the
      // latest schema/LOV/permission changes for the table the user is
      // actually looking at), so it must always win over whatever
      // hydrateMdmConfig has stored for that same table — hence
      // preferIncomingData: true. Tables this payload has no `data` for
      // (i.e. every table except the selected one) fall back to whatever
      // was already there, preserving any hydrated `data` merged in by an
      // earlier MERGE_HYDRATED_CONFIG.
      return {
        ...state,
        mdmConfig: mergeConfigs(state.mdmConfig, action.payload, { preferIncomingData: true }),
        loadedConfig: true,
        loadingConfig: false,
      };
    case SET_CONFIG_ERROR:
      return {
        ...state,
        loadingConfig: false,
        loadedConfig: false,
        error: action.payload,
        mdmConfig: [],
      };
    case SET_DATA_BEGIN:
      return { ...state, loadingData: true, loadedData: false, error: null };
    case SET_DATA:
      // `data` and `rollBackData` must each be an independent deep clone of the
      // payload. The payload often comes straight from the React Query cache
      // (dmGridContainer dispatches setMdmData(query.data.data)); AG Grid mutates
      // row objects in place while editing, so if `data` shared references with the
      // payload those edits would silently poison the cache. That poisoned cache is
      // then reloaded when the user navigates away and back, resurrecting edits that
      // were supposed to be discarded. Cloning here keeps the cache pristine and lets
      // `rollBackData` serve as a clean baseline for discarding unsaved changes.
      // structuredClone instead of cloneDeep: action.payload is normally JSON-safe
      // (server data, or the grid's own row data after edits/deletes — see the
      // setMdmData(this.props.data, ...) and setMdmData(rollBackData) call sites in
      // dataManagement/index.js, which pass back live grid state, not fresh server
      // JSON), so structuredClone reproduces it exactly while avoiding cloneDeep's
      // main-thread cost on very large tables. structuredClone throws DataCloneError
      // on values it truly can't clone (functions, DOM nodes, etc.) — fall back to
      // cloneDeep rather than crashing the reducer if a row ever picks one up.
      let clonedData;
      let rollBackData;
      try {
        clonedData = structuredClone(action.payload);
        rollBackData = structuredClone(action.payload);
      } catch (err) {
        clonedData = cloneDeep(action.payload);
        rollBackData = cloneDeep(action.payload);
      }
      const effectiveRowCount = action.rowCount !== undefined ? action.rowCount : state.rowCount;
      const effectiveNextRow = action.nextRow !== undefined ? action.nextRow : state.nextRowToLoad;
      if (action.payload.length === 0) {
        return {
          ...state,
          data: clonedData,
          rollBackData,
          loadingData: false,
          loadedData: true,
          loadingAppendData: false,
          rowCount: effectiveRowCount,
          lastId: 0,
          nextRowToLoad: 0,
        };
      } else {
        return {
          ...state,
          data: clonedData,
          rollBackData,
          loadingData: false,
          loadedData: true,
          loadingAppendData: false,
          rowCount: effectiveRowCount,
          // Never let lastId regress: a refetch after a save (e.g. a partial-save
          // failure) reports the server's real max ID, which is unaffected by rows
          // that failed to save — but the client had already handed out higher
          // client-side IDs to those still-unsaved placeholder/added rows before this
          // dispatch. Setting lastId back down to the server's max would let the next
          // new row reuse one of those still-in-use IDs. Since AG Grid keys rows by ID
          // (getRowId), that collision makes the grid conflate the two rows into one
          // node — silently dropping/overwriting whichever row loses the slot, or (if
          // both survive to the save payload) getting both inserted server-side under
          // the same client id, which the server treats as two unrelated new rows.
          //
          // Compute the true max over the whole payload, not just its last element —
          // the server's row order isn't guaranteed to reflect insertion/ID order (no
          // ORDER BY on the underlying query), so the highest ID can land anywhere.
          lastId: action.payload.reduce((max, row) => Math.max(max, row.ID), state.lastId),
          nextRowToLoad: effectiveNextRow,
        };
      }
    case APPEND_DATA:
      let newAppendData = cloneDeep(state.data);
      newAppendData = newAppendData.concat(action.payload);
      return {
        ...state,
        data: newAppendData,
        loadingAppendData: false,
        lastId: action.payload[action.payload.length - 1].ID,
        nextRowToLoad: action.nextRow,
        refresh: true,
      };
    case BEGIN_SET_DATA_APPEND:
      return { ...state, loadingAppendData: true };
    case ADD_DATA:
      let newData = cloneDeep(state.data);
      let newRowCount;

      if (!Array.isArray(action.payload)) {
        newRowCount = state.data[state.data.length - 1].ID + 1;
        newData.push(action.payload);
      } else {
        if (state.data.length === 0) {
          newRowCount = action.payload.length;
        } else {
          newRowCount = state.data[state.data.length - 1].ID + action.payload.length;
        }
        action.payload.forEach((item) => {
          newData.push(item);
        });
      }

      return {
        ...state,
        data: newData,
        lastId: newRowCount,
      };
    case REMOVE_DATA:
      let rmData = action.payload.map((item) => {
        return item.data.ID;
      });
      let modData = cloneDeep(state.data).filter((datum) => {
        return !rmData.includes(datum.ID);
      });

      return { ...state, data: modData };
    case BEGIN_SET_MDM_APPS:
      return { ...state, mdmAppsLoaded: false, mdmAppsLoading: true };
    case SET_MDM_APPS_STATUS:
      return {
        ...state,
        mdmApps: action.payload,
        mdmAppsLoaded: true,
        mdmAppsLoading: false,
      };
    case REQUEST_ACTIONS:
      return { ...state, actionsRequestId: action.requestId };
    case SET_ACTIONS:
      // Ignore a response from a request that's since been superseded by a newer
      // one - getActions() has no request cancellation, so an older in-flight
      // request (even one still retrying with backoff for the SAME table) can
      // resolve after a newer request has already been dispatched, and would
      // otherwise overwrite the current actions list with stale/wrong data.
      if (action.requestId !== state.actionsRequestId) {
        return state;
      }
      return { ...state, actions: action.payload, lastRunAction: action.lastRunAction };
    case SET_FULL_LOAD:
      return { ...state, fullLoad: action.payload };
    case SET_REFRESH:
      return { ...state, refresh: action.payload };

    case SET_INFO_DIALOG:
      return { ...state, info: action.payload };
    case SET_ERROR_DIALOG:
      return { ...state, errorMessage: action.payload };
    case SET_LOADED_DATA_STATUS:
      return { ...state, loadedData: action.payload };
    case SET_EXT_FILTER:
      //let newFilter = cloneDeep(state.externalFilter);
      // if(newFilter.length === 0){
      //   newFilter = [];
      // }
      //newFilter.push(action.payload);
      return {
        ...state,
        externalFilter: action.payload,
        externalFilterUpdate: true,
      };
    case SET_EXT_FILTER_UPDATE:
      return {
        ...state,
        externalFilterUpdate: action.payload,
      };
    case DUPLICATE_ROW:
      return {
        ...state,
        data: [...state.data.slice(0, action.payload.index), action.payload.row, ...state.data.slice(action.payload.index)],
        // lastId: state.lastId + 1,
        // refresh: true,
      };
    case MERGE_HYDRATED_CONFIG:
      // hydrateMdmConfig (getFullMdmConfig) returns `data` for every table, but
      // since it runs concurrently with getMdmConfig for the selected table, this
      // response can resolve after the selected table already has fresh `data`
      // from SET_CONFIG. preferIncomingData defaults to false here, so any
      // existing (selected-table) data is preserved rather than being overwritten
      // by this now-stale hydration payload; tables with no prior data yet are
      // still populated from the hydrated payload.
      return {
        ...state,
        mdmConfig: mergeConfigs(state.mdmConfig, action.payload),
      };
    case "SET_HYDRATE_CONFIG_BEGIN":
      return {
        ...state,
        loadingHydratedConfig: true,
        loadedHydratedConfig: false,
      };
    case "SET_HYDRATE_CONFIG_SUCCESS":
      return {
        ...state,
        loadingHydratedConfig: false,
        loadedHydratedConfig: true,
      };
    case SET_NEXT_ROW_TO_LOAD: {
      return {
        ...state,
        nextRowToLoad: action.payload, // or maybe you do rowCount if you prefer
      };
    }
    case UPDATE_LOV_VALUES: {
      const lovs = action.payload; // array of { objectId, columnName, values }

      // Create a new mdmConfig with LOVs updated
      const newConfig = state.mdmConfig.map((table) => {
        // Find matching lovs for this table
        const lovsForTable = lovs.filter((lov) => lov.objectId === table.id);

        if (!table.data || lovsForTable.length === 0) {
          return table;
        }

        // Update columns in this table's data
        const newData = table.data.map((col) => {
          const lov = lovsForTable.find((l) => l.columnName === col.field);
          if (lov) {
            return {
              ...col,
              cellEditorParams: {
                ...col.cellEditorParams,
                values: lov.values,
              },
            };
          }
          return col;
        });

        return {
          ...table,
          data: newData,
        };
      });

      return {
        ...state,
        mdmConfig: newConfig,
      };
    }
    case UPDATE_ACTION_RUN: {
      const { actionId, lastRunTime, lastRunBy } = action.payload;
      return {
        ...state,
        actions: state.actions.map((act) => (act.id === actionId ? { ...act, lastRunTime, lastRunBy } : act)),
        lastRunAction: {
          ...state.lastRunAction,
          ACTION_GROUP_NAME: state.actions.find((act) => act.id === actionId)?.label || "",
          LAST_RUN_TIME: lastRunTime,
          LAST_RUN_BY: lastRunBy,
          error: undefined,
        },
      };
    }
    case "INCREMENT_LAST_ID":
      return { ...state, lastId: state.lastId + 1 };
    case "INCREMENT_LAST_ID_BY":
      return { ...state, lastId: state.lastId + action.payload };
    case "UPDATE_ROW_FIELD":
      return {
        ...state,
        data: state.data.map((row) =>
          row.ID === action.payload.rowId ? { ...row, [action.payload.field]: action.payload.newValue } : row,
        ),
      };
    case UPDATE_TABLE_ROW_COUNT: {
      const { tableIdx, newCount } = action.payload;
      const newMdmConfig = [...state.mdmConfig];
      newMdmConfig[tableIdx] = { ...newMdmConfig[tableIdx], rowCount: newCount };
      return { ...state, mdmConfig: newMdmConfig };
    }
    default:
      return state;
  }
};
